import { isDictionary } from '../unknowns/isDictionary';

export const deepCopy = <T>(value: T): T => {
  if (value instanceof RegExp) {
    return new RegExp(value) as T;
  } else if (value instanceof Date) {
    return new Date(value) as T;
  } else if (isDictionary(value)) {
    return deepCopyDictionary(value);
  } else if (Array.isArray(value)) {
    return deepCopyArray(value);
  } else if (typeof value === 'function') {
    return deepCopyFunction(value);
  }

  return value;
};

export const deepCopyDictionary = <T extends Record<string, unknown>>(dict: T): T => {
  const dictKeys = Object.keys(dict);

  return dictKeys.reduce<Record<string, unknown>>((acc, key) => {
    acc[key] = deepCopy(dict[key]);

    return acc;
  }, {}) as T;
};

export const deepCopyArray = <T extends Array<T>>(array: T): T => {
  return array.map(item => deepCopy(item)) as T;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const deepCopyFunction = <T>(fn: T & Function): T => {
  return ((...args: unknown[]): unknown => {
    return fn(...args);
  }) as T;
};
